import { render, staticRenderFns } from "./DarkModeSwitch.vue?vue&type=template&id=20608a45&scoped=true"
import script from "./DarkModeSwitch.vue?vue&type=script&lang=js"
export * from "./DarkModeSwitch.vue?vue&type=script&lang=js"
import style0 from "./DarkModeSwitch.vue?vue&type=style&index=0&id=20608a45&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20608a45",
  null
  
)

export default component.exports